import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function EditFill({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6918 4.21524C10.4137 3.93839 9.96387 3.93915 9.68669 4.21695L4.5124 9.40298C4.33377 9.58075 4.23339 9.82188 4.23334 10.0733V11.2993C4.23334 11.5508 4.33368 11.7919 4.5123 11.9697C4.69092 12.1475 4.93318 12.2474 5.18579 12.2474H6.4173C6.66989 12.2474 6.91211 12.1475 7.09068 11.9696L12.2638 6.78474C12.5415 6.5065 12.5407 6.05581 12.2621 5.77851L10.6918 4.21524Z"
                fill={color}/>
        </svg>
    );
}

export default EditFill;
